//ALL COLORS
export const colors = {
  main: "#003366",
  light: "#f18c52",
  dark: "#cf692e",
  gray: "#7b7b7b",
  hoverBtnLight: "#fbfbfb",
  paperLightGray: "#F9F9F9",
  paperLightGrayBorder: "#DADADA",
  paperLightOrange: "#FFF1EA",
  paperLightOrangeHover: "#fce4d9",
  mjRedOutline: "#f0625f",
  mjRedText: "#632726",
  mjGreenOutline: "#5bb65f",
  mjGreenText: "#1e4620",
  mjYellowOutline: "#af6906",
  tFieldGray: "#d9d9d9",
  textDark: "#212121",
  mj_error: "#ec5656",

  //v2

  //text colors
  text_subtitle: "#666D83",
  text_subtitle_dark: "#4A526C",
  text_chip: "#2E3755",
  text_description: "#2E3755",
  text_clickable: "#0065FF",

  //component colors
};
